import { useTranslations } from "@/lib/static-intl";
import React, { useEffect, useState } from "react";

export default function ToastComp({
  message,
  duration = 2000,
  isVisible = false,
  onClose,
}) {
  const explorePostDetailsT = useTranslations("explore.explore_post_details");
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        onClose?.();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 pointer-events-none flex items-center justify-center z-50">
      <div
        className={`transform transition-all duration-300 ease-in-out ${
          show ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"
        } px-6 py-3 rounded-full bg-gray-900/90 dark:bg-gray-100/90 text-white dark:text-gray-900 text-sm font-medium shadow-lg`}
      >
        {message || explorePostDetailsT("copy_successful")}
      </div>
    </div>
  );
}
